<template>
    <div
        class="Questionnaire"
        v-if="init"
        :class="{ paddingTop1: showAppTips }"
    >
        <div class="appTips" v-show="showAppTips">
            <div class="leftIntroduce">
                <img
                    class="introduceLogo"
                    :src="require('@/common/images/header/introduce_logo.png')"
                    alt=""
                />
                <div class="introduce">
                    <div class="introduceTitle">鲸融网APP</div>
                    <div class="tips">让资本赋能企业成长</div>
                </div>
            </div>
            <div class="rightBtn">
                <a href="https://m.capwhale.com/mapp">立即打开</a>
            </div>
            <img
                class="close"
                @click="hideAppTips"
                :src="require('@/common/images/header/closeAppTips.png')"
                alt=""
            />
        </div>
        <div
            class="ques-header"
            :style="
                'background:url(' +
                (item.coverurl ? item.coverurl : bgQuesHeader) +
                ') 100%;background-size: 100%;'
            "
        >
            <div class="mask">
                <div class="name">{{ item.name }}</div>
                <div class="desp">{{ item.desp }}</div>
            </div>
        </div>
        <div class="ques-body" v-if="item.commonformlist.length">
            <div
                class="box"
                v-for="(obj, index) in item.commonformlist"
                :key="index"
                :class="[obj.checked ? '' : 'ques-error']"
            >
                <div class="colname">
                    {{ obj.colname
                    }}<span v-if="obj.isnotnull" class="tc-red">*</span>
                </div>
                <div
                    class="innerbox text"
                    v-if="[1, 2, 4].indexOf(obj.coltype) > -1"
                >
                    <!--文本-->
                    <van-field
                        v-if="obj.datatype == 1"
                        type="text"
                        v-model="obj.colvalue"
                        :placeholder="obj.placeholder"
                    />
                    <!--数字number digit-->
                    <van-field
                        v-if="obj.datatype == 2"
                        type="digit"
                        v-model="obj.colvalue"
                        :placeholder="obj.placeholder"
                    />
                    <!--电话号码-->
                    <van-field
                        v-if="obj.datatype == 3"
                        type="tel"
                        v-model="obj.colvalue"
                        :maxlength="11"
                        :placeholder="obj.placeholder"
                    />
                    <!--身份证-->
                    <van-field
                        v-if="obj.datatype == 4"
                        :placeholder="obj.placeholder"
                        readonly
                        clickable
                        :value="obj.colvalue"
                        @touchstart.native.stop="openIdcardKeyboard(obj)"
                    />
                    <van-number-keyboard
                        :show="obj.show"
                        v-model="obj.colvalue"
                        :maxlength="18"
                        extra-key="X"
                        close-button-text="完成"
                        @blur="obj.show = false"
                    />
                    <!--邮箱-->
                    <van-field
                        v-if="obj.datatype == 5"
                        type="text"
                        v-model="obj.colvalue"
                        :placeholder="obj.placeholder"
                    />
                </div>
                <div class="innerbox date" v-if="[3].indexOf(obj.coltype) > -1">
                    <div class="flexbetween">
                        <van-cell
                            is-link
                            :title="obj.placeholder"
                            :value="obj.colvalue"
                            @click="openCalendar(obj)"
                        />
                        <van-action-sheet
                            v-model="obj.show"
                            close-on-click-action
                        >
                            <div class="content">
                                <van-datetime-picker
                                    v-model="date"
                                    type="date"
                                    :title="obj.colname"
                                    @confirm="onConfirmDate(obj)"
                                    @cancel="onCancel(obj)"
                                />
                            </div>
                        </van-action-sheet>
                    </div>
                </div>
                <div class="innerbox date" v-if="[9].indexOf(obj.coltype) > -1">
                    <div class="flexbetween">
                        <van-cell
                            is-link
                            :title="obj.placeholder"
                            :value="obj.colvalue"
                            @click="openCalendar(obj)"
                        />
                        <van-action-sheet
                            v-model="obj.show"
                            close-on-click-action
                        >
                            <div class="content">
                                <van-datetime-picker
                                    v-model="time"
                                    type="time"
                                    :title="obj.colname"
                                    @confirm="onConfirmTime(obj)"
                                    @cancel="onCancel(obj)"
                                />
                            </div>
                        </van-action-sheet>
                    </div>
                </div>
                <div
                    class="innerbox textarea"
                    v-if="[5].indexOf(obj.coltype) > -1"
                >
                    <van-field
                        type="textarea"
                        v-model="obj.colvalue"
                        :placeholder="obj.placeholder"
                    />
                </div>
                <div
                    class="innerbox radio"
                    v-if="[6].indexOf(obj.coltype) > -1"
                >
                    <van-radio-group v-model="obj.colvalue">
                        <van-radio
                            :name="obj2"
                            v-for="(obj2, index2) in obj.optionsinfo"
                            :key="index2"
                            >{{ obj2 }}</van-radio
                        >
                    </van-radio-group>
                </div>
                <div
                    class="innerbox checkbox"
                    v-if="[7].indexOf(obj.coltype) > -1"
                >
                    <van-checkbox-group v-model="obj.colvalue">
                        <van-checkbox
                            :name="obj2"
                            v-for="(obj2, index2) in obj.optionsinfo"
                            :key="index2"
                            >{{ obj2 }}</van-checkbox
                        >
                    </van-checkbox-group>
                </div>
                <div
                    class="innerbox checkbox"
                    v-if="[8].indexOf(obj.coltype) > -1"
                >
                    <div class="flexbetween">
                        <van-dropdown-menu>
                            <van-dropdown-item
                                v-model="obj.colvalue"
                                :options="obj.optionsinfo"
                            />
                        </van-dropdown-menu>
                    </div>
                </div>
            </div>
            <div class="ques-footer" v-if="item.iscanjoin">
                <div class="btnBox">
                    <van-button type="info" size="large" @click="submit"
                        >提交</van-button
                    >
                </div>
                <div class="bottomTips">
                    <div class="tips">
                        本问卷由
                        <span class="name" @click="goAgencyView">{{
                            item.hostname
                        }}</span>
                        提供
                    </div>
                    <div class="logoTips">
                        <img
                            class="logoIcon"
                            :src="require('@/common/images/mmy/logo_icon.png')"
                            alt=""
                        />
                        <span class="name" @click="goIndex">鲸融网</span>
                        提供技术支持
                    </div>
                </div>
            </div>
        </div>
        <noData v-if="!item.iscanjoin">
            <div>{{ item.joinmessage }}</div>
        </noData>
        <div class="ques-tip" v-if="isSubSuccess">
            <div class="outbox">
                <img v-lazy="imgSuccess" alt="" class="img" />
            </div>
            <div>问卷提交成功，谢谢参与！</div>
        </div>
    </div>
</template>

<script>
import { getCourseCommonformInfo, uploadCommonFormInfo } from "api/api";
import { mapActions, mapGetters } from "vuex";
import NoData from "views/mobile/components/noData/noDataList";
import { getWXSDKSetting } from "common/js/wxSDKSetting";
import $ from "jquery";
export default {
    name: "Questionnaire",
    data() {
        return {
            // coltype 字段类型：1 单行文本框  2 数字文本框  3 日期选择框  4 邮箱输入框   5 多行文本框  6 单选按钮框   7 多选按钮框  8 下拉选择框  9时间选择框
            // datatype 字段数据类型： 1 文本 2 数字 3 手机号码 4 身份证号码 5 邮箱
            param: {
                commonid: this.$route.query.commonid
                    ? this.$route.query.commonid
                    : "",
                kmcinnerid: this.$route.query.kmcinnerid
                    ? this.$route.query.kmcinnerid
                    : "",
                kmctype: this.$route.query.kmctype
                    ? this.$route.query.kmctype
                    : "",
            },
            bgQuesHeader:
                "https://img.capwhale.com/kmc/commonform_cover_default.png",
            init: false,
            item: {
                commonid: "",
                coverurl: "",
                desp: "",
                name: "",
                commonformlist: [],
                iscanjoin: 0,
                joinmessage: "",
                hostid: "",
                hostname: "",
            },
            date: null,
            time: null,
            selectIndex: null,
            isSubSuccess: false,
            imgSuccess: require("@/common/images/course/img_success.png"),
        };
    },
    mounted() {
        console.log("page 1");
        if (this.user.isLogin) {
            if (!this.refresh) {
                this._getView();
            }
        } else {
            this.$toast.fail("请先登录");
            console.log("page 2");
            if (this.ClientType == 3 && window.__wxjs_is_wkwebview) {
                //ios微信
                let fullpath =
                    "/m/naire?commonid=" +
                    this.param.commonid +
                    "&kmctype=" +
                    this.param.kmctype +
                    "&kmcinnerid=" +
                    this.param.kmcinnerid;
                this.$router.push({
                    name: "MLogin",
                    query: { redirect: fullpath },
                });
            } else {
                this.$router.push({ name: "MLogin" });
            }
        }
    },
    activated() {
        if (this.user.isLogin) {
            if (this.refresh) {
                this.param = {
                    commonid: this.$route.query.commonid,
                    kmcinnerid: this.$route.query.kmcinnerid,
                    kmctype: this.$route.query.kmctype,
                };
                this._getView();
            }
        } else {
            this.$toast.fail("请先登录");
            if (this.ClientType == 3 && window.__wxjs_is_wkwebview) {
                //ios微信
                let fullpath =
                    "/m/naire?commonid=" +
                    this.param.commonid +
                    "&kmctype=" +
                    this.param.kmctype +
                    "&kmcinnerid=" +
                    this.param.kmcinnerid;
                this.$router.push({
                    name: "MLogin",
                    query: { redirect: fullpath },
                });
            } else {
                this.$router.push({ name: "MLogin" });
            }
        }
    },
    methods: {
        openIdcardKeyboard(obj) {
            obj.show = true;
            $("input").focus();
        },
        openCalendar(obj) {
            this.date = null;
            this.time = null;
            obj.show = true;
        },
        onConfirmDate(obj) {
            obj.colvalue =
                this.date.getFullYear() +
                "-" +
                (this.date.getMonth() + 1) +
                "-" +
                this.date.getDate();
            obj.show = false;
        },
        onConfirmTime(obj) {
            obj.colvalue = this.time;
            obj.show = false;
        },
        onCancel(obj) {
            obj.show = false;
        },
        submit() {
            let userformlist = [];
            this.item.commonformlist.forEach((obj) => {
                let colinnerid = obj.colinnerid;
                let colvalue =
                    obj.coltype == 7 ? obj.colvalue.join(",") : obj.colvalue;
                if (obj.isnotnull && obj.colvalue === "") {
                    obj.checked = false;
                } else {
                    obj.checked = true;
                    userformlist.push({
                        colinnerid: colinnerid,
                        colvalue: colvalue,
                    });
                }
            });
            if (this.item.commonformlist.length == userformlist.length) {
                this._save({ userformlist: JSON.stringify(userformlist) });
            } else {
                this.$toast.fail("请填写必填项");
            }
        },
        _save(item) {
            this.setLoading(true);
            uploadCommonFormInfo({
                data: Object.assign({}, item, this.param),
                success: () => {
                    this.setLoading(false);
                    this.isSubSuccess = true;
                    this.item.commonformlist = [];
                },
                error: (data) => {
                    this.setLoading(false);
                    this.$toast.fail(data.msg);
                },
            });
        },
        _getView() {
            this.setLoading(true);
            getCourseCommonformInfo({
                data: this.param,
                success: (data) => {
                    if (data.data.iscanjoin) {
                        data.data.commonformlist.forEach((obj) => {
                            obj.show = false;
                            obj.checked = true;
                            if ([7].indexOf(obj.coltype) > -1) {
                                obj.colvalue = [];
                            } else if ([8].indexOf(obj.coltype) > -1) {
                                let list = [
                                    { text: obj.placeholder, value: "" },
                                ];
                                obj.optionsinfo.forEach((obj2) => {
                                    list.push({
                                        text: obj2,
                                        value: obj2,
                                    });
                                });
                                obj.optionsinfo = list;
                            }
                        });
                    } else {
                        data.data.commonformlist = [];
                    }
                    this.item = data.data;
                    document.title = this.item.name;
                    if (this.ClientType == 3) {
                        getWXSDKSetting({
                            title: this.item.sharesubject,
                            desc: this.item.sharedesp,
                            link: window.location.href,
                            imgUrl: this.item.shareimageurl,
                        });
                    }
                    this.init = true;
                    this.setLoading(false);
                },
                error: (data) => {
                    this.setLoading(false);
                    this.$toast.fail(data.msg);
                },
            });
        },
        goAgencyView() {
            this.$router.push({
                name: "MAgencyView",
                query: {
                    hostid: this.item.hostid,
                },
            });
        },
        goIndex() {
            location.href = "https://m.capwhale.com/";
        },
        hideAppTips() {
            this.setShowAppTips(false);
        },
        ...mapActions([
            "setLoading",
            "setRefresh",
            "setNoDataTip",
            "setShowAppTips",
        ]),
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            "refresh",
            "domainInfo",
            "user",
            "ClientType",
            "showAppTips",
        ]),
    },
    components: {
        NoData,
    },
};
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Questionnaire {
    &.paddingTop1 {
        padding-top: 1.1rem;
    }
    .appTips {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 1.1rem;
        background: #fafafa;
        padding: 0.24rem 0.48rem 0.24rem 0.34rem;
        box-sizing: border-box;
        position: fixed;
        width: 100%;
        z-index: 1000;
        top: 0;
        left: 0;
        .leftIntroduce {
            display: flex;
            align-items: center;
            .introduceLogo {
                width: 0.62rem;
                height: 0.62rem;
                margin-right: 0.2rem;
            }
            .introduce {
                .introduceTitle {
                    font-size: 0.28rem;
                    color: #333333;
                    font-size: 0.28rem;
                    // line-height: 0.36rem;
                    font-weight: bold;
                }
                .tips {
                    font-size: 0.2rem;
                    color: #999999;
                    line-height: 0.28rem;
                }
            }
        }
        .rightBtn {
            a {
                display: block;
                width: 1.5rem;
                height: 0.52rem;
                line-height: 0.52rem;
                background: #1677ff;
                color: #fff;
                text-align: center;
                font-size: 0.28rem;
                border-radius: 0.04rem;
            }
        }
        .close {
            width: 0.32rem;
            height: 0.32rem;
            position: absolute;
            top: 0;
            right: 0;
        }
    }
    .ques-header {
        height: 3.2rem;
        background-repeat: no-repeat !important;
        background-size: 7.5rem 3.2rem !important;
        position: relative;

        .mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            text-align: center;
            .name {
                margin-top: 0.7rem;
                font-size: 0.32rem;
            }
            .desp {
                font-size: 0.24rem;
                margin-top: 0.3rem;
                padding: 0 0.2rem;
                line-height: 0.32rem;
            }
        }
    }
    .ques-body {
        // padding-bottom: 2.4rem;
        .box {
            background: #fff;
            padding: 0 0.32rem;
            font-size: 0.3rem;
            .colname {
                padding-top: 0.32rem;
            }
            .van-icon {
                font-size: 0.26rem;
            }
            .van-cell,
            .van-radio-group,
            .van-checkbox-group,
            .van-dropdown-menu__item {
                padding: 0.28rem 0 0.32rem 0;
            }
            .van-radio__icon,
            .van-radio,
            .van-checkbox {
                display: flex;
                align-items: center;
            }
            .van-radio + .van-radio,
            .van-checkbox + .van-checkbox {
                margin-top: 0.4rem;
            }
            .van-dropdown-menu {
                height: auto;
                .van-dropdown-item {
                    border-top: 0.01rem solid #eee;
                    .van-cell {
                        padding: 0.1rem 0.32rem;
                    }
                }
                .van-dropdown-menu__title {
                    padding: 0;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    &:after {
                        margin-right: 0.16rem;
                    }
                }
            }
            .van-hairline--top-bottom::after,
            .van-hairline-unset--top-bottom::after {
                border: none;
            }
        }
        .box + .box {
            border-top: 0.01rem solid #eeeeee;
        }
        .box.ques-error .colname {
            color: #ff4747;
        }
    }
    .ques-footer {
        // position: fixed;
        // bottom:0;
        // left: 0;
        // right:0;
        height: 2.2rem;
        .btnBox {
            padding: 0.15rem 0.32rem;
            box-sizing: border-box;
            background: #fff;
            .van-button {
                height: 0.7rem;
                line-height: 0.7rem;
                font-size: 0.3rem;
                border-radius: 0.38rem;
                font-weight: 400;
            }
        }
        .bottomTips {
            background: #f5f7fa;
            height: 1.2rem;
            // padding: 0.2rem 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .tips {
                text-align: center;
                font-size: 0.24rem;
                color: #999999;
                margin-bottom: 0.1rem;
                .name {
                    color: #1364c8;
                }
            }
            .logoTips {
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0.24rem;
                color: #999999;
                .logoIcon {
                    width: 0.42rem;
                    height: 0.3rem;
                    margin-right: 0.1rem;
                }
                .name {
                    color: #1364c8;
                    margin-right: 0.1rem;
                }
            }
        }
    }
    .noData {
        background: #fff;
        height: calc(100vh - 3.2rem);
        .noData-img {
            margin-top: -3.5rem;
        }
    }
    .ques-tip {
        font-size: 0.3rem;
        padding-top: 1.5rem;
        color: #999;
        background: #fff;
        height: calc(100vh - 3.2rem);
        box-sizing: border-box;
        text-align: center;
        .outbox {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }
        .img {
            width: 2.34rem;
            height: 2.56rem;
            margin-bottom: 0.32rem;
        }
    }
}
</style>